import { useEffect, useRef, useState } from 'react';

const useConditionalDebounce = (
    value,
    delayMs,
    shouldDebounce = () => true,
) => {
    const [debouncedValue, setDebouncedValue] = useState(value);
    const id = useRef(null);

    useEffect(() => {
        if (shouldDebounce(value)) {
            id.current = setTimeout(() => {
                setDebouncedValue(value);
            }, delayMs);

            return () => clearTimeout(id.current);
        }

        clearTimeout(id.current);
        setDebouncedValue(value);
    }, [value, delayMs, shouldDebounce]);

    return debouncedValue;
};

export default useConditionalDebounce;
